'use es6';

import { memo, useRef, useState } from 'react';
import get from 'transmute/get';
import PropTypes from 'prop-types';
import { getFullUrl } from 'hubspot-url-utils';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { AGENT } from 'conversations-message-history/constants/messageUses';
import { generateUuid } from 'conversations-message-history/util/generateUuid';
import PrimaryMessage from '../primary-message/components/PrimaryMessage';
import PrimaryMessageContent from '../primary-message/components/PrimaryMessageContent';
import PrimaryMessageContentSection from '../primary-message/components/PrimaryMessageContentSection';
import { usePostMessageHandler } from '../utils/usePostMessageHandler';
import { jsx as _jsx } from "react/jsx-runtime";
const isLocal = window.location.host.includes('local');
const FeedbackSurveyMessage = /*#__PURE__*/memo(({
  message,
  sessionId,
  hubspotUtk,
  threadId
}) => {
  const uuidRefContainer = useRef(generateUuid());
  const [iframeHeight, setIframeHeight] = useState(160);
  const handlers = {
    RESIZE_IFRAME: ({
      data
    }) => {
      setIframeHeight(data.height);
    }
  };
  usePostMessageHandler(uuidRefContainer.current, handlers);
  const urlSearchParams = new URLSearchParams({
    uuid: uuidRefContainer.current,
    sessionId,
    hubspotUtk,
    threadId
  });
  const iframeSrc = `${getFullUrl(isLocal ? 'local' : 'app')}/feedback-in-chat/${get('feedbackTransactionId', message)}?${urlSearchParams}`;
  return /*#__PURE__*/_jsx(PrimaryMessage, {
    use: AGENT,
    children: /*#__PURE__*/_jsx(PrimaryMessageContent, {
      children: /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
        children: /*#__PURE__*/_jsx("iframe", {
          src: iframeSrc,
          style: {
            width: '100%',
            height: iframeHeight,
            border: 0
          }
        })
      })
    })
  });
});
FeedbackSurveyMessage.displayName = 'FeedbackSurveyMessage';
FeedbackSurveyMessage.propTypes = {
  hubspotUtk: PropTypes.string,
  message: RecordPropType('FeedbackSurveyMessage').isRequired,
  sessionId: PropTypes.string,
  threadId: PropTypes.string
};
export default FeedbackSurveyMessage;